import React, {PureComponent} from 'react'
import CSSModules from 'react-css-modules'
import { isSameDay } from 'react-dates'
import moment from 'moment'
import TextLink from 'components/text_link/text_link'
import DateRangePicker from 'components/date_range_picker/date_range_picker'
import { Tooltip } from 'components/tooltip'

import Isvg from 'react-inlinesvg'
import { dateFormatArrayFromTimestamp, formatRemainingTime } from 'helpers/dateFormat/dateFormat'
import dateformat from 'dateformat'
import { localize } from 'helpers/translator'
import classNames from 'classnames'
import CalendarSvg from 'assets/components/lesson_codes_list/calendar-icon.svg'

import styles from './lesson_codes_list.scss'

class LessonCodesListItem extends PureComponent {

	constructor() {
		super()
		this.handleDateSelection = this.handleDateSelection.bind(this)
		this.handleToggleCode = this.handleToggleCode.bind(this)
	}

	handleDateSelection() {
		this.props.handleDateSelection(this.props.code.sessionUid, this.props.code.expireTime)
	}

	handleToggleCode() {
		this.props.handleToggleCode(this.props.code.sessionUid)
	}

	momentToSeconds = moment => moment.hours() * 3600 + moment.minutes() * 60 + moment.seconds()

	shouldDisableDay = day => {
		const now = moment()
		const { launchedTime } = this.props.code

		const launch = moment.unix(launchedTime)
		const currentTimeInSeconds = this.momentToSeconds(now)
		const launchedTimeInSeconds = this.momentToSeconds(launch)

		const currentTimeIsHigher = (currentTimeInSeconds - launchedTimeInSeconds) > 0
		return isSameDay(day, now) && currentTimeIsHigher
	}

	render() {
		const { launchedTime, pincode, expireTime, isSelected } = this.props.code
		const expiresIn = formatRemainingTime(launchedTime, expireTime, this.props.actualTimestamp)
		return (
			<li>
				<div styleName={classNames({
					'code-list-item': true,
					/* "clickable" class to be used should items be selectable */
					'code-list-item--clickable': this.props.isSelectable,
					'code-list-item--clickable-selected': isSelected,
				})}>
					<div styleName='code-list-item-column-two' onClick={this.handleToggleCode}>
						<div styleName='code-list-item-column'>
							<p styleName='code-list-item-column-date'>{dateformat(launchedTime * 1000, 'mmm dd')} <span styleName='code-list-item-column-date-time'>{this.props.dateText} {dateformat(launchedTime * 1000, 'h:MM tt')}</span></p>
						</div>
						<div styleName='code-list-item-column'>
							<p styleName={classNames({
								'code-list-item-column-code': true,
								/* "clickable" class to be used should items be selectable */
								'code-list-item-column-code-bold': this.props.isSelectable,
							})}>
								{pincode.toUpperCase()}
							</p>
						</div>
					</div>
					<div styleName='code-list-item-column' onClick={this.handleDateSelection} >
						<div styleName='code-list-item-column-expiration'>
							{this.props.canChangeExpirationDate ?
								<TextLink>
									<p styleName='code-list-item-column-expiration-link'>{`${expiresIn} ${localize('code_list_remaining')}`}
										<Isvg src={CalendarSvg} cacheGetRequests={true} styleName='icon-date' />
									</p>
									<div styleName='code-list-item-column-expiration-tooltip'>
										<Tooltip arrow='top-center'>{localize('code_list_tooltip')}</Tooltip>
									</div>
								</TextLink>
								:
								<p styleName='code-list-item-column-expiration-label'>{expiresIn}</p>
							}
						</div>
					</div>
				</div>
				{this.props.hasCalendarActive &&
					<div styleName='code-list-item-datepicker'>
						<DateRangePicker
							startDate={dateFormatArrayFromTimestamp(launchedTime)}
							endDate={dateFormatArrayFromTimestamp(expireTime)}
							minimumNights={1}
							maxDays={365}
							saveHandler={this.props.handleSaveExpirationDate}
							cancelHandler={this.props.handleCancelDate}
							dateChangeHandler={this.props.dateChangeHandler}
							shouldDisableDay={this.shouldDisableDay}
						/>
					</div>
				}
			</li>
		)
	}
}

export default CSSModules(LessonCodesListItem, styles, { allowMultiple: true })
